import stocardIcon from '../assets/Stocard.png';
import miniprintIcon from '../assets/miniprint.png';
import dzenlyIcon from '../assets/dzenly.png';
import truckSensorIcon from '../assets/truck sensor.png';
import msqrdIcon from '../assets/msqrd.png';
import kubaturnikIcon from '../assets/kubaturnik.jpg';

export const DEFAULT_APP_ID = 'stocard';

const apps = [
  {
    id: 'msqrd',
    name: { en: 'msqrd', ru: 'msqrd' },
    tagline: {
      en: 'AI photo filters and looks — try a template, share it in the feed.',
      ru: 'AI-фильтры и образы для фото — примерьте шаблон и поделитесь в ленте.',
    },
    description: {
      en: 'msqrd turns a photo into a new look with AI templates. Sign in, generate, publish to the public feed, and buy tokens or Premium when you need more.',
      ru: 'msqrd меняет фото с помощью AI-шаблонов. Войдите, сгенерируйте работу, опубликуйте её в общей ленте и докупайте токены или Premium, когда нужно больше.',
    },
    icon: msqrdIcon,
    appStoreUrl: null,
    version: '0.0.1',
    genres: {
      en: ['Photo & Video', 'Entertainment'],
      ru: ['Фото и видео', 'Развлечения'],
    },
    rating: null,
    ratingCount: 0,
    comingSoon: true,
    accent: '#D6FF3F',
    accentSecondary: '#D2B4FF',
  },
  {
    id: 'stocard',
    appleId: '6749338079',
    name: { en: 'Stocard', ru: 'Stocard' },
    tagline: {
      en: 'Digital loyalty card wallet — scan, store, and use every store card in one app.',
      ru: 'Цифровой кошелёк карт лояльности — сканируйте и храните все карты в одном приложении.',
    },
    description: {
      en: 'Stocard is your ultimate digital card wallet. Easily scan and organize every loyalty card in one app to save at checkout. Say goodbye to bulky plastic and embrace a smarter way to shop.',
      ru: 'Stocard — ваш цифровой кошелёк карт. Сканируйте и организуйте все карты лояльности в одном приложении. Забудьте о пластике и покупайте умнее.',
    },
    icon: stocardIcon,
    appStoreUrl:
      'https://apps.apple.com/by/app/stocard-loyalty-card-wallet/id6749338079',
    version: '1.1.7',
    genres: {
      en: ['Shopping', 'Finance'],
      ru: ['Покупки', 'Финансы'],
    },
    rating: 5,
    ratingCount: 1,
    comingSoon: false,
    accent: '#7c3aed',
    accentSecondary: '#3b82f6',
  },
  {
    id: 'miniprint',
    appleId: '6758412942',
    name: { en: 'MiniPrint', ru: 'MiniPrint' },
    tagline: {
      en: 'Bluetooth thermal printing made easy — photos, stickers, notes, and labels.',
      ru: 'Печать на мини-принтере по Bluetooth — фото, стикеры, заметки и этикетки.',
    },
    description: {
      en: 'Turn your smartphone into a creative hub with MiniPrint. Connect your mini pocket printer via Bluetooth and print photos, stickers, study notes, and custom labels instantly — no ink required.',
      ru: 'Превратите смартфон в творческий центр с MiniPrint. Подключите карманный принтер по Bluetooth и печатайте фото, стикеры, заметки и этикетки мгновенно — без чернил.',
    },
    icon: miniprintIcon,
    appStoreUrl:
      'https://apps.apple.com/by/app/miniprint-mini-printer/id6758412942',
    version: '0.0.4',
    genres: {
      en: ['Utilities', 'Entertainment'],
      ru: ['Утилиты', 'Развлечения'],
    },
    rating: null,
    ratingCount: 0,
    comingSoon: false,
    accent: '#f97316',
    accentSecondary: '#ec4899',
  },
  {
    id: 'dzenly',
    appleId: '6783349540',
    name: { en: 'Dzenly', ru: 'Dzenly' },
    tagline: {
      en: 'Your daily zen and mindfulness companion — breathe, relax, and reset.',
      ru: 'Ежедневный помощник для спокойствия и осознанности — дышите и расслабляйтесь.',
    },
    description: {
      en: 'A calm space for mindfulness, breathing exercises, and daily reflection.',
      ru: 'Спокойное пространство для осознанности, дыхательных практик и ежедневной рефлексии.',
    },
    icon: dzenlyIcon,
    appStoreUrl:
      'https://apps.apple.com/by/app/dzenly-antistress-relaxing/id6783349540',
    version: '1.0.1',
    genres: {
      en: ['Health & Fitness', 'Lifestyle'],
      ru: ['Здоровье', 'Стиль жизни'],
    },
    rating: 5,
    ratingCount: 2,
    comingSoon: false,
    accent: '#14b8a6',
    accentSecondary: '#06b6d4',
  },
  {
    id: 'truck-queue-sensor',
    appleId: '6778471507',
    name: {
      en: 'Truck Queue Sensor',
      ru: 'Датчик колейки',
    },
    tagline: {
      en: 'Smart queue tracker for truck drivers — get alerted when the line starts moving.',
      ru: 'Умный датчик колейки для дальнобойщиков — сигнал, когда очередь сдвинулась.',
    },
    description: {
      en: 'A professional alarm for truck drivers that turns your phone into a queue tracker. Point the camera at the vehicle ahead — when traffic moves, you get an instant loud alert so you never miss your turn in line.',
      ru: 'Профессиональный будильник для дальнобойщиков. Наведите камеру на машину впереди — как только колонна сдвинется, приложение подаст громкий сигнал, и вы не проспите свою очередь.',
    },
    icon: truckSensorIcon,
    appStoreUrl:
      'https://apps.apple.com/by/app/%D0%B4%D0%B0%D1%82%D1%87%D0%B8%D0%BA-%D0%BA%D0%BE%D0%BB%D0%B5%D0%B9%D0%BA%D0%B8-%D0%B4%D0%BB%D1%8F-%D0%B2%D0%BE%D0%B4%D0%B8%D1%82%D0%B5%D0%BB%D0%B5%D0%B9/id6778471507',
    version: '1.0.0',
    genres: {
      en: ['Utilities', 'Productivity'],
      ru: ['Утилиты', 'Продуктивность'],
    },
    rating: null,
    ratingCount: 0,
    comingSoon: false,
    accent: '#eab308',
    accentSecondary: '#22c55e',
  },
  {
    id: 'kubaturnik',
    appleId: '6800798767',
    name: {
      en: 'Cubature — Lumber',
      ru: 'Кубатурник — леса/доски',
    },
    tagline: {
      en: 'Quick lumber volume calculator for boards and timber on site.',
      ru: 'Быстрый расчёт кубатуры леса и досок прямо на объекте.',
    },
    description: {
      en: 'Calculate board and timber volume on site without tables or guesswork.',
      ru: 'Считайте объём леса и досок на объекте — без таблиц и прикидок.',
    },
    icon: kubaturnikIcon,
    appStoreUrl:
      'https://apps.apple.com/by/app/%D0%BA%D1%83%D0%B1%D0%B0%D1%82%D1%83%D1%80%D0%BD%D0%B8%D0%BA-%D0%BB%D0%B5%D1%81%D0%B0-%D0%B4%D0%BE%D1%81%D0%BA%D0%B8/id6800798767',
    version: '1.0.0',
    genres: {
      en: ['Utilities', 'Productivity'],
      ru: ['Утилиты', 'Продуктивность'],
    },
    rating: null,
    ratingCount: 0,
    comingSoon: false,
    accent: '#b45309',
    accentSecondary: '#ca8a04',
  },
];

export function resolveAppId(id) {
  if (id && apps.some((app) => app.id === id)) return id;
  return DEFAULT_APP_ID;
}

export function getAppById(id) {
  return apps.find((app) => app.id === resolveAppId(id));
}

export default apps;
